/** @format */

import React, { useEffect, useState } from 'react'
import Checkbox from '../../../../../Components/Checkbox/Checkbox'
import EnumsServerCombo from '../../../../../Components/ComboBox/EnumsServerCombo'
import Loader from '../../../../../Components/Loaders/Loader'
import ChartOfAccountsLookup from '../../../../../Components/Lookup/ChartOfAccountsLookup'
import FuneralHomeLookup from '../../../../../Components/Lookup/FuneralHomeLookup'
import ModalTemplate from '../../../../../Components/ModalTemplate/ModalTemplate'
import localize from '../../../../../Global/Localize'
import { showNotification } from '../../../../../Helpers/Notification/ShowNotification'
import { postData } from '../../../../../Helpers/webApi'
import { GlobalValidationErrors } from '../../../../../Validation/ValidationState'

const CreateMorgueRoom = ({
  mode,
  handleClose,
  fetchMorgueRooms,
  setMorgueRoom,
  morgueRoom,
}) => {
  const [isBusy, setIsBusy] = useState(false)
  const [globalValidationErrors, setGlobalValidationErrors] =
    GlobalValidationErrors.use()

  const clearValidation = column => {
    setGlobalValidationErrors(g => {
      delete g[column]
      return g
    })
  }

  const handleSelectMorgueRoom = room => {
    if (room?.isLocked)
      return showNotification(
        'Operation not allowed',
        'error',
        'You cannot select a locked room'
      )

    clearValidation('FuneralHomeDescription')
    setMorgueRoom({
      ...morgueRoom,
      funeralHomeId: room.id,
      funeralHomeDescription: room.description,
    })
  }

  const handleAddOrUpdate = async () => {
    const message = mode === 'add' ? 'Create Morgue Room' : 'Edit Morgue Room'
    const url = mode === 'add' ? '/Room/add-room' : '/Room/update-room'
    setIsBusy(true)

    const { success } = await postData(url, morgueRoom, false)
    if (success) {
      fetchMorgueRooms()
      handleClose()
      showNotification(message, 'success')
    }

    setIsBusy(false)
  }

  useEffect(() => {
    setGlobalValidationErrors({})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode])

  return (
    <ModalTemplate
      modalMode={mode}
      modalTitle="morgueRoom"
      disableClose={isBusy}
      handleAction={handleAddOrUpdate}
      modalClassName="modal-xl"
      handleClose={handleClose}
      disableCreate={isBusy}
      footerChildren={
        <div className="d-flex align-items-center">
          <Checkbox
            disabled={isBusy}
            id="editRoomIsLocked"
            checked={morgueRoom?.isLocked}
            onCheck={e => {
              setMorgueRoom({
                ...morgueRoom,
                isLocked: e,
              })
            }}
          />
          <label
            className="ms-2 me-4 text-capitalize"
            htmlFor="editRoomIsLocked"
          >
            {localize('isLocked')} ?
          </label>
        </div>
      }
    >
      {isBusy ? (
        <Loader />
      ) : (
        <div className="row g-3">
          <div className="col-md-6">
            <div
              className="d-flex align-items-center with-validation"
              validation-message={
                globalValidationErrors['Description']?.message
              }
            >
              <label htmlFor="name" className="text-capitalize col-1 pe-2">
                {localize('name')}
              </label>

              <input
                type="text"
                id="name"
                className="form-control"
                value={morgueRoom?.description || ''}
                onChange={e => {
                  clearValidation('Description')
                  setMorgueRoom({
                    ...morgueRoom,
                    description: e.target.value,
                  })
                }}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="d-flex align-items-center">
              <label className="text-capitalize col-1 pe-2">
                {localize('type')}
              </label>
              <EnumsServerCombo
                customContainerStyle={{ width: '100%' }}
                enumsKey="RoomType"
                value={morgueRoom.type}
                onChange={e => {
                  setMorgueRoom({
                    ...morgueRoom,
                    type: e.value,
                  })
                }}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div
              className="d-flex align-items-center with-validation"
              validation-message={
                globalValidationErrors['FuneralHomeDescription']?.message
              }
            >
              <label
                htmlFor="funeralHome"
                className="text-capitalize col-1 pe-2"
              >
                {localize('funeralHome')}
              </label>

              <FuneralHomeLookup
                displayValue={morgueRoom?.funeralHomeDescription || ''}
                onSelect={handleSelectMorgueRoom}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div
              className="d-flex align-items-center with-validation"
              validation-message={
                globalValidationErrors['ChartOfAccountName']?.message
              }
            >
              <label
                htmlFor="G/LAccount"
                className="text-capitalize col-1 pe-2"
              >
                {localize('g/LAccount')}
              </label>

              <ChartOfAccountsLookup
                displayValue={
                  morgueRoom?.chartOfAccountAccountName ||
                  morgueRoom?.chartOfAccountName ||
                  ''
                }
                onSelect={e => {
                  clearValidation('ChartOfAccountName')
                  setMorgueRoom({
                    ...morgueRoom,
                    chartOfAccountId: e.id,
                    chartOfAccountName: e.description,
                  })
                }}
              />
            </div>
          </div>
        </div>
      )}
    </ModalTemplate>
  )
}

export default CreateMorgueRoom
